// @ts-nocheck
// Import React and Hooks
import React, { useState, useEffect } from 'react'
// Import React Router Dom
import { useHistory } from 'react-router-dom'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch, useAppSelector } from '../hooks/useRedux'
// Import Actions
import { registerUserAction } from '../actions/registerAction'
// Import React Hook Form
import { useForm } from 'react-hook-form'
// Import Custom Hooks
import useFormCustom from '../hooks/useFormCustom'
// Import Services
import { get } from './../services/api'
// Import React Awesome Reveal
// import { Fade } from "react-awesome-reveal"
// Import Components
import Background from '../components/layout/Background'
import Loader from '../components/ui/Loader'
import Button from '../components/ui/Button'



const Register = () => {



  // Use Selector
  const registerData = useAppSelector( state => state.register )



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use History
  const history = useHistory()



  // Use state
  const [ gender ] = useState([
    {
      value: 'Hombre',
      text: 'Hombre',
    },
    {
      value: 'Mujer',
      text: 'Mujer',
    },
    {
      value: 'Prefiero no decir',
      text: 'Prefiero no decir',
    }
  ])
  const [ allInputs, setAllInputs ] = useState([
    {
      id: 'registerName',
      label: 'Nombre',
      placeholder: 'Ingresa tu Nombre',
      type: 'normal',
      typeInput: 'text',
      validation: {
        required: "Este campo es requerido"
      }
    },
    {
      id: 'registerSurname',
      label: 'Apellido',
      placeholder: 'Ingresa tu(s) Apellidos',
      type: 'normal',
      typeInput: 'text',
      validation: {
        required: "Este campo es requerido"
      }
    },
    {
      id: 'registerEmail',
      label: 'Correo Electrónico',
      placeholder: 'Ingresa tu correo',
      type: 'normal',
      typeInput: 'email',
      validation: {
        required: "Este campo es requerido",
        pattern: {
          // value: /\S+@\S+\.\S+/,
          value: /^[^\s+]+@\S+\.\S+/,
          message: "Ingrese un email válido"
        }
      }
    },
    {
      id: 'registerPhone',
      label: 'Teléfono',
      placeholder: '000 000 0000',
      type: 'normal',
      typeInput: 'number',
      maxlength: 10,
      validation: {
        required: "Este campo es requerido",
        min: {
          value: 1000000,
          message: "Mínimo 7 números"
        },
        max: {
          value: 9999999999,
          message: "Máximo 10 números"
        }
      }
    },
    {
      id: 'registerGender',
      label: 'Género',
      placeholder: 'Selecciona tu Género',
      type: 'select',
      typeInput: 'select',
      options: gender,
      validation: {
        required: "Este campo es requerido"
      }
    },
    {
      id: 'registerBirthday',
      title: 'Fecha de nacimiento',
      type: 'group',
      inputElements: [
        {
          id: 'registerBirthdayDay',
          placeholder: 'DD',
          type: 'normal',
          typeInput: 'number',
          maxlength: 2,
          validation: {
            required: "Este campo es requerido",
            min: {
              value: 1,
              message: "Mínimo 1 (día)"
            },
            max: {
              value: 31,
              message: "Máximo 31 (días)"
            }
          }
        },
        {
          id: 'registerBirthdayMonth',
          placeholder: 'MM',
          type: 'normal',
          typeInput: 'number',
          maxlength: 2,
          validation: {
            required: "Este campo es requerido",
            min: {
              value: 1,
              message: "Mínimo 1 (mes)"
            },
            max: {
              value: 12,
              message: "Máximo 12 (meses)"
            }
          }
        },
        {
          id: 'registerBirthdayYear',
          placeholder: 'YYYY',
          type: 'normal',
          typeInput: 'number',
          maxlength: 4,
          validation: {
            required: "Este campo es requerido",
            min: {
              value: 1920,
              message: "Mínimo 1920 (año)"
            },
            max: {
              value: 2021,
              message: "Máximo 2021 (año)"
            }
          }
        }
      ]
    },
    {
      id: 'registerState',
      label: 'Estado',
      placeholder: 'Selecciona uno',
      type: 'select',
      typeInput: 'select',
      options: [],
      validation: {
        required: "Este campo es requerido"
      }
    },
    {
      id: 'registerZIP',
      label: 'Código Postal',
      placeholder: 'Ingresa tu código postal',
      type: 'normal',
      maxlength: 5,
      typeInput: 'number',
      validation: {
        required: "Este campo es requerido"
      }
    },
    {
      id: 'registerTerms',
      label: '<a href="/terminos-y-condiciones" target="_blank" class="form__link">Acepto Términos, condiciones </a> <a href="https://www.grupomodelo.com/abilegal/politica-deproteccion-de-datos-personales" target="_blank"> y aviso de privacidad.</a>',
      type: 'checkbox',
      typeInput: 'checkbox',
      validation: {
        required: "Este campo es requerido",
      }
    },
    {
      id: 'registerInfo',
      label: 'Deseo recibir información comercial y eventos de Grupo Modelo',
      type: 'checkbox',
      typeInput: 'checkbox',
      validation: {}
    }
  ])



  // Get States
  const getStates = async () => {

    interface optionInterface {
      value:string,
      text:string
    }

    const response:any = await get('/victoriaddm/get/countries', true)
    const allStates:optionInterface[] = await response.map( (dataItem:any) => ({
      value: (dataItem.name).toLowerCase(),
      text: dataItem.name
    }) )
    setAllInputs( allInputs.map( (item:any) => {
      if( item.id === 'registerState' ) {
        item = {
          ...item,
          options: allStates
        }
      }
      return item
    } ) )

  }



  // Use Effect
  useEffect( () => {

    getStates()

  }, [] )



  // Config React Hook Form
  // const { register, getValues, handleSubmit, formState: { errors } } = useForm()
  const { register, handleSubmit, formState: { errors } } = useForm()



  // Use Form Custom
	const { printInput } = useFormCustom()

  type PropsDataRegister = {
    registerBirthdayDay:string,
    registerBirthdayMonth:string,
    registerBirthdayYear:string
    registerEmail:string,
    registerGender:string,
    registerName:string,
    registerSurname:string,
    registerState:string,
    registerPhone:string,
    registerZIP:string
    registerInfo:boolean,
    registerTerms:boolean,
  }


  const calculateAge = (dateOfBirth: string): number => { // format "2000/10/30"
    const today = new Date();
    const birthday = new Date(dateOfBirth);
    let age = today.getFullYear() - birthday.getFullYear();
    const m = today.getMonth() - birthday.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
        age--;
    }
    return age;
  }

  // Functions
	const onSubmit = (data: PropsDataRegister) => {
    const { registerBirthdayDay, registerBirthdayMonth, registerBirthdayYear } = data
    const age = calculateAge(`${registerBirthdayYear}/${registerBirthdayMonth}/${registerBirthdayDay}`);

    if(age >= 18){
      dispatch( registerUserAction( data, history ) )
    }else{
      const p = document.createElement('p')
      p.className = 'form__error'
      p.textContent = 'debe ser mayor de edad'
      const formItem = document.getElementById('registerBirthdayDay') as HTMLInputElement
      formItem.parentElement!.appendChild(p)
      formItem.focus()
      formItem.parentElement!.parentElement!.addEventListener('click', () => formItem.nextElementSibling!.remove())
    }
  }

  return (
    <div className="container container--register">
      <Background type='both-side' />
        <form
        id="ex"
        className="form"
        encType='multipart/form-data'
        onSubmit={ handleSubmit( onSubmit ) } >
        <h1 className="form__title">
          Regístrate
        </h1>
        <h2 className="form__text mb35">
          PARTICIPA EN EL SORTEO DE un six de latas PERSONALIZADA CON TU <br/> DEDICATORIA
        </h2>
        <div className="form__wrapper">
          {
            allInputs.map( (inputEl) => {
              return printInput( inputEl, register, errors, inputEl.id === 'registerTerms' ? 'mt20' : ''  )
            } )
          }
        </div>
        <div className="dF w100 form__box taC mt30 mb0">
          <Button
            type='submit'
            text='Crea una ofrenda'
            />
        </div>
      </form>
    </div>
  )
}



export default Register
